import {css, html, LitElement} from 'lit';
import {PreviewBoxContent} from './sp-preview-boxes';
import {customElement} from 'lit/decorators.js';
import {property} from 'lit/decorators.js';
import {SpImageService} from "../../services/sp-image.service";
import {classMap} from "lit/directives/class-map.js";
import {when} from "lit/directives/when.js";

@customElement('sp-preview-box')
export class SpPreviewBox extends LitElement {
    @property({type: String})
    public icon: string;
    @property({type: Boolean})
    public selected = false;
    @property({type: Object})
    public previewImage: PreviewBoxContent;

    static styles =
        // language=CSS
        css`
            :host {
                width: 2.25rem;
                height: 2.25rem;
                margin: 0 0.2rem 0 0.2rem;
                position: relative;
                cursor: pointer;
            }
            
            .icon-button {
                width: 100%;
                height: 100%;
                background-color: rgb(var(--sp-color-a));
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 35%;
                border-radius: 1.125rem;
            }

            .button {
                width: 2rem;
                height: 2rem;
                border-radius: 1.125rem;
                overflow: hidden;
            }
            
            .button-not-active {
                background-color: white;
                border: 0.125rem solid white;
            }

            .button-active  {
                background-color: rgb(var(--sp-greydark));
                border: 0.125rem solid rgb(var(--sp-greydark));
                cursor: default;
            }

            sp-image::part(spinner) {
                --track-width: 0.2rem;
                font-size: 1.6rem;
            }
        `;

    protected render() {
        return when(this.icon,
            () => html`
                    <div class="icon-button" style="background-image: url(${this.icon})"></div>`,
            () => html`
                    <sp-image
                        class=${classMap({
                            button: true,
                            'button-active': this.selected,
                            'button-not-active': !this.selected
                        })}
                        .image=${ this.previewImage?.image ? 
                                SpImageService.buildUrl('spots', 'thumbs', this.previewImage?.image?.path, 'x200') :
                                SpImageService.getPlaceholderUrl('spots')}>
                    </sp-image>`);
    }
}
